import { useModal } from 'vue-final-modal'
import ModalMessage from '~/components/Modal/ModalMessage.vue'
import { blockScroll, unBlockScroll } from '~/composables/blockScroll'

export async function messagesModal (slots: any, closeCallback?: () => Promise<void>) {
    const messagesModalInstance = useModal({
        component: ModalMessage,
        attrs: {
            onBeforeOpen () {
                blockScroll(window.scrollY)
            },
            onBeforeClose () {
                unBlockScroll()
            },
            onClose: async () => {
                await messagesModalInstance.close()
                if (closeCallback) {
                    await closeCallback()
                }
            }
        },
        slots
    })
    await messagesModalInstance.open()
    return messagesModalInstance
}
